export const ACCOUNT = "/account";

export const ACCOUNT_USER = ACCOUNT + "/user";
export const ACCOUNT_TERMS = ACCOUNT + "/terms";
export const ACCOUNT_DELETE = ACCOUNT + "/delete";
export const VERIFY_EMAIL = "/verify-email/:uid/:token";
